import { render, staticRenderFns } from "./TablaInfoGral.vue?vue&type=template&id=6efe23ee&scoped=true&"
import script from "./TablaInfoGral.vue?vue&type=script&lang=ts&"
export * from "./TablaInfoGral.vue?vue&type=script&lang=ts&"
import style0 from "./TablaInfoGral.vue?vue&type=style&index=0&id=6efe23ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe23ee",
  null
  
)

export default component.exports